<script>import { ctx } from "../ctx.js";
export let closeOnOutsideClick = void 0;
export let closeOnEscape = void 0;
export let portal = void 0;
export let forceVisible = void 0;
export let open = void 0;
export let onOpenChange = void 0;
export let preventScroll = void 0;
export let arrowSize = void 0;
export let positioning = void 0;
export let loop = void 0;
export let dir = void 0;
const {
  states: { open: localOpen },
  updateOption
} = ctx.set({
  closeOnOutsideClick,
  closeOnEscape,
  portal,
  forceVisible,
  defaultOpen: open,
  preventScroll,
  arrowSize,
  positioning,
  loop,
  dir,
  onOpenChange: ({ next }) => {
    open = next;
    onOpenChange?.(next);
    return next;
  }
});
$:
  open !== void 0 && localOpen.set(open);
$:
  updateOption("closeOnOutsideClick", closeOnOutsideClick);
$:
  updateOption("closeOnEscape", closeOnEscape);
$:
  updateOption("portal", portal);
$:
  updateOption("forceVisible", forceVisible);
$:
  updateOption("preventScroll", preventScroll);
$:
  updateOption("arrowSize", arrowSize);
$:
  updateOption("positioning", positioning);
$:
  updateOption("loop", loop);
$:
  updateOption("dir", dir);
</script>

<slot />
